import axios from 'axios';

export function getReqLDRates({page, limit, filter}) {

    return axios({
        method: 'POST',
        url: '/api/v1/reqRates/',
        withCredentials: true, 
        data: {
            page,
            limit,
            filter: filter,
        },  
    }).then(response => response.data)
    .catch(response => response.data);
}

export function deleteReqLDRate(_id) {
    return axios({
        method: 'DELETE',
        url: '/api/v1/reqRates/',
        withCredentials: true, 
        data: {
            _id
        },  
    }).then(response => response.data)
    .catch(response => response.data);
}

export function editReqLDRate(data) {
    let { cargoWeight, cargoVolume } = data;

    if(!cargoWeight && cargoVolume) {
        delete data.cargoWeight;
    } else if(cargoWeight && !cargoVolume) {
        delete data.cargoVolume;
    }

    return axios({
        method: 'PUT',
        url: '/api/v1/reqRates/',
        withCredentials: true,
        data,
    }).then(response => response.data)
    .catch(response => response.response.data);
}

export function addReqLDRate(data) {

    let { cargoWeight, cargoVolume } = data;

    if(!cargoWeight && cargoVolume) {
        delete data.cargoWeight;
    } else if(cargoWeight && !cargoVolume) {
        delete data.cargoVolume;
    }

    return axios({
        method: 'POST',
        url: '/api/v1/reqRates/add',
        withCredentials: true,
        data,
    }).then(response => response.data)
    .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/reqLDRates.js